import { graphql } from '@graphql/__generated'

export const UPDATE_ORDER = graphql(`
  mutation UpdateOrder($input: UpdateOrderInput!) {
    updateOrder(input: $input)
  }
`)
